import React, { useEffect, useState } from 'react'

import { API, Storage } from 'aws-amplify'
import { getStaffProfile } from '../../managers/graphql/queries'

// mui
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// redux
import { useAppDispatch, useAppSelector } from '../../hooks'
import { getStaffList } from '../../managers/redux/slices/team'
import { reloadAuthAccount } from '../../managers/redux/slices/authAccount'
import { getFundraisingCampaigns, setSelectedFundraisingCampaign } from '../../managers/redux/slices/fundraising'

import ManageCampaignDialog from '../../components/dialogs/fundraising/ManageCampaignDialog'

import { StaffProfile, FundraisingCampaign } from '../../API'
import ProfileAvatar from '../../components/data-display/ProfileAvatar'

export default function Campaigns(props: any) {

    // redux
    const dispatch = useAppDispatch()
    const authAccount = useAppSelector(state => state.authAccount)
    const fundraising = useAppSelector(state => state.fundraising)

    // dialog
    const [showManageCampaignDialog, setShowManageCampaignDialog] = useState(false)

    useEffect(() => {
        (async () => {
            if (authAccount.cognitoData == null) {
                await dispatch(reloadAuthAccount())
            }
            dispatch(getFundraisingCampaigns())
        })()
    }, [])

    useEffect(() => {
        console.log(fundraising.campaigns)
    }, [fundraising.campaigns])

    return (
        <div className="p-5 d-flex flex-column justify-content-start">
            <div className="d-flex flex-row justify-content-end w-100">
                <Button
                    onClick={() => {
                        setShowManageCampaignDialog(true)
                    }}
                    variant="contained"
                >
                    Create Campaign
                </Button>
            </div>

            {
                fundraising && fundraising.campaigns != null && fundraising.campaigns.length == 0 &&
                <Typography variant="h4">No campaigns yet.</Typography>
            }

            {
                fundraising && fundraising.campaigns != null && fundraising.campaigns.length > 0 &&
                <div className="row">
                    {
                        fundraising.campaigns.map((campaign: FundraisingCampaign) => {
                            return <CampaignCard campaign={campaign}
                                openManageDialogCallback={() => {

                                }}
                            />
                        })
                    }
                </div>
            }

            {/* DIALOG */}
            <ManageCampaignDialog visible={showManageCampaignDialog} onClose={() => setShowManageCampaignDialog(false)} />

        </div>
    )
}

interface CampaignCardProps {
    campaign: FundraisingCampaign,
    openManageDialogCallback: () => void
}

export function CampaignCard(props: CampaignCardProps) {

    console.log('campaign data: ', props.campaign)

    const [staffProfile, setStaffProfile] = useState<StaffProfile | null>(null)
    const [headerImageURI, setHeaderImageURI] = useState<string | null>(null)
    const [logoImageURI, setLogoImageURI] = useState<string | null>(null)

    const dispatch = useAppDispatch()

    useEffect(() => {
        (async () => {
            if (props.campaign && props.campaign.staffLead) {
                const { data }: any = await API.graphql({
                    query: getStaffProfile,
                    variables: {
                        id: props.campaign.staffLeadID
                    }
                })
                console.log(data)
                setStaffProfile(data.getStaffProfile)
            }
            if (props.campaign.customHeaderImageUploaded) {
                const uri = await Storage.get(`campaigns/${props.campaign.id}/headerImage`)
                setHeaderImageURI(uri)
            } else {
                const uri = await Storage.get(`organizations/${props.campaign.organizationID}/headerImage`)
                setHeaderImageURI(uri)
            }
            if (props.campaign.customLogoImageUploaded) {
                const uri = await Storage.get(`campaigns/${props.campaign.id}/logoImage`)
                setLogoImageURI(uri)
            } else {
                const uri = await Storage.get(`organizations/${props.campaign.organizationID}/profilePicture`)
                setLogoImageURI(uri)
            }
        })()
    }, [])

    useEffect(() => {
        console.log(staffProfile)
    }, [staffProfile])

    if (props.campaign != null) {
        return (
            <div className="col-12 col-lg-4">
                <Box className="d-flex flex-column justify-content-center align-items-center my-3 border" sx={{ cursor: 'pointer', ":hover": { boxShadow: 'rgb(0 0 0 / 15%) 0px 0.5rem 1rem' }, borderRadius: '15px' }} onClick={() => { dispatch(setSelectedFundraisingCampaign({ id: props.campaign.id })) }}>
                    <div className="w-100 d-flex flex-coliumn justify-content-center align-items-center" style={{ height: 200, position: 'relative' }}>
                        <img src={headerImageURI ? headerImageURI : ''} style={{ width: '100%', height: 200, objectFit: 'cover', borderTopRightRadius: 15, borderTopLeftRadius: 15, backgroundColor: 'white', opacity: 0.5 }} />
                        <img src={logoImageURI ? logoImageURI : ''} style={{ width: 150, height: 100, objectFit: 'contain', position: 'absolute' }} />
                    </div>
                    <div className="p-3 d-flex flex-column justify-content-start align-items-start bg-white w-100" style={{ borderBottomRightRadius: 15, borderBottomLeftRadius: 15 }}>
                        <Typography variant="h3">{props.campaign.campaignName}</Typography>
                        <div className="d-flex flex-row justify-content-center align-items-center mt-2">
                            {
                                staffProfile && staffProfile.authAccountID &&
                                <ProfileAvatar authAccountID={staffProfile.authAccountID} />
                            }
                            <Typography variant="body1" className="mx-2">{staffProfile && staffProfile.authAccount ? staffProfile.authAccount.name ? staffProfile.authAccount.name : staffProfile.authAccount.firstName && staffProfile.authAccount.lastName ? `${staffProfile.authAccount.firstName} ${staffProfile.authAccount.lastName}` : '' : 'Not Assigned'}</Typography>
                        </div>
                    </div>
                </Box>
            </div>
        )
    } else {
        return (
            <div />
        )
    }

}